export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7965.8741b537.jpg";